import { Injectable } from '@angular/core';

@Injectable()
export class PayUService {
  
  private _payUPaymentURL = '';
  private _accessToken = '';
  private _proformaNumber = '';

  constructor() { }

  get payUPaymentURL() {
    return this._payUPaymentURL;
  }

  set payUPaymentURL(URL) {
    this._payUPaymentURL = URL;
  }
  
  get accessToken() {
    return this._accessToken;
  }

  set accessToken(accessToken) {
    this._accessToken = accessToken;
  }


  get proformaNumber() {
    return this._proformaNumber;
  }

  set proformaNumber(proformaNumber) {
    this._proformaNumber = proformaNumber;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/payu.service.ts